"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _lhJsCommonLib = require("@lifehikes/lh-js-common-lib");
var _hike = require("@/api/hike");
var _moment = _interopRequireDefault(require("moment"));
var _filters = require("@/filters");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'HikeFeedbackResult',
  components: {},
  directives: {},
  async created() {
    await this.getHike();
  },
  data() {
    return {
      firstTab: 'stage1',
      hike: null,
      hikeStages: [{
        id: "ffddd"
      }, {
        id: "ffddd3"
      }],
      feedbackResults: [],
      isShowResult: false,
      noOfSuccess: 0,
      noOfFail: 0,
      tableData: [],
      tableHeader: [],
      smallDrop: 'smallDrop',
      loading: false
    };
  },
  methods: {
    handleSuccess({
      results,
      header
    }) {
      // console.log('upload excel file-result', results)
      // console.log('upload excel file-header', results)
      this.tableData = _lodash.default.map(results, function (r) {
        return {
          hikeId: _lodash.default.trim(r.hikeId),
          email: _lodash.default.trim(_lodash.default.toLower(r.email)),
          givenName: _lodash.default.trim(r.givenName),
          familyName: _lodash.default.trim(r.familyName),
          orgName: _lodash.default.trim(r.orgName),
          jobTitle: _lodash.default.trim(r.jobTitle)
        };
      });
      this.tableHeader = header;
    },
    getHike() {
      const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      return (0, _hike.getHikeById)(token, id).then(response => {
        this.hike = response.data;
        this.hikeStages = this.hike.stages;

        // No stages, show Post Program Feedback tab
        if (this.hikeStages.length == 0) {
          this.firstTab = 'postProgramFeedback';
        }
        //

        this.$set(this, 'hike', response.data);
        this.$set(this, 'hikeStages', this.hike.stages);
        this.hike.stages.forEach((item, index) => {
          console.info("stage id:" + item.id);
          this.getHikeFeedbackResults(item.id, 'stage' + (index + 1));
        });
        this.getPostProgramFeedbackResults();
        this.loading = false;
        return this.hike;
      }).catch(error => {
        (0, _log.showDebugLog)('hike-getHikeById-error', error);
        this.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    async getPostProgramFeedbackResults() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var hikeId = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      const linkedResource = (0, _lhJsCommonLib.formatLhrn)('hike', hikeId, 'postprogramfeedback');
      await (0, _hike.getFeedbackResults)(token, hikeId, null, linkedResource).then(response => {
        const results = [];
        for (const result of response.data) {
          const date = _moment.default.utc(result.completeTimeUtc);
          result.completeTimeUtc = date.format('YYYY-MM-DD HH:mm:ss');
          // result.stageId = stageId;
          result.stageName = 'postProgramFeedback';
          // result.stageIndex = stageName.toString().replace('stage', '');
          results.push(result);
        }
        const newItem = this.feedbackResults.concat(results);
        this.$set(this, 'feedbackResults', newItem);
      }).catch(error => {
        (0, _log.showDebugLog)('Hike-getPostProgramFeedbackResults-API-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    async getHikeFeedbackResults(stageId, stageName) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var hikeId = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      await (0, _hike.getFeedbackResults)(token, hikeId, stageId).then(response => {
        const results = [];
        for (const result of response.data) {
          const date = _moment.default.utc(result.completeTimeUtc);
          result.completeTimeUtc = date.format('YYYY-MM-DD HH:mm:ss');
          result.stageId = stageId;
          result.stageName = stageName;
          result.stageIndex = stageName.toString().replace('stage', '');
          results.push(result);
        }
        const newItem = this.feedbackResults.concat(results);
        this.$set(this, 'feedbackResults', newItem);
      }).catch(error => {
        (0, _log.showDebugLog)('Hike-getHikeFeedbackResults-API-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    onStageBtnClicked(tab, event) {
      // Ref https://stackoverflow.com/questions/54938719/how-to-get-key-value-in-tab-element-ui
      const index = tab.$vnode.key;
      // const stageId = this.hikeStages[index].id
    },
    backToHike() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push(`/hike/edit/${id}`);
    },
    downloadHikeFeedBack() {
      const excelHeader = ['Stage', 'Participant ID', 'Name', 'Question', 'Answer', 'Complete time (UTC)'];
      const hikeFeedBackData = [];
      let exportData = _lodash.default.cloneDeep(this.feedbackResults.filter(result => result.stageName !== 'postProgramFeedback'));
      exportData = _lodash.default.sortBy(exportData, ['stageIndex'], ['asc']);
      exportData.forEach((feedback, index) => {
        feedback.answers.forEach((answer, answerIdx) => {
          const data = [feedback.stageIndex, feedback.participantUuid, feedback.participantGivenName + ' ' + feedback.participantFamilyName, answer.questionText, answer.answer, feedback.completeTimeUtc];
          hikeFeedBackData.push(data);
        });
      });
      // Export to excel
      Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'))).then(excel => {
        excel.export_json_to_excel({
          header: excelHeader,
          data: hikeFeedBackData,
          filename: 'hike_feedback_export',
          bookType: 'csv'
        });
      });
    },
    downloadPostProgramFeedBack() {
      const excelHeader = ['Participant Email', 'Question', 'Answer', 'Complete time (UTC)'];
      const feedbackData = [];
      const exportData = _lodash.default.cloneDeep(this.feedbackResults.filter(result => result.stageName === 'postProgramFeedback'));
      exportData.forEach((feedback, index) => {
        feedback.answers.forEach((answer, answerIdx) => {
          const data = [feedback.fillerEmail ? feedback.fillerEmail : 'N/A (Anonymous)', answer.questionText, answer.answer, feedback.completeTimeUtc];
          feedbackData.push(data);
        });
      });
      // Export to excel
      Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'))).then(excel => {
        excel.export_json_to_excel({
          header: excelHeader,
          data: feedbackData,
          filename: 'post_program_feedback_export',
          bookType: 'csv'
        });
      });
    }
  }
};